var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getFromSessionStorage, removeFromSessionStorage, SESSION_STORAGE_KEYS, setInSessionStorage } from "../data/sessionStorageHelpers";
export function useSeatCode() {
    var location = useLocation();
    var _a = __read(useState(), 2), seatCode = _a[0], setSeatCodeState = _a[1];
    useEffect(function () {
        var _a;
        // First, try to get seatCode from URL parameters
        var search = location.search.toLowerCase();
        var urlSeatCode = (_a = new URLSearchParams(search).get("seatcode")) !== null && _a !== void 0 ? _a : "";
        // If we have a seatCode in the URL, use it and save to session storage
        if (urlSeatCode) {
            setInSessionStorage(SESSION_STORAGE_KEYS.SEAT_CODE, urlSeatCode);
            setSeatCodeState(urlSeatCode);
            return;
        }
        // If no seatCode in URL, try to get from session storage
        var storedSeatCode = getFromSessionStorage(SESSION_STORAGE_KEYS.SEAT_CODE);
        if (storedSeatCode) {
            setSeatCodeState(storedSeatCode);
        }
        else {
            setSeatCodeState("");
        }
    }, [location.search]);
    var setSeatCode = function (code) {
        setInSessionStorage(SESSION_STORAGE_KEYS.SEAT_CODE, code);
        setSeatCodeState(code);
    };
    var clearSeatCode = function () {
        removeFromSessionStorage(SESSION_STORAGE_KEYS.SEAT_CODE);
        setSeatCodeState("");
    };
    return { seatCode: seatCode, setSeatCode: setSeatCode, clearSeatCode: clearSeatCode };
}
